var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 12,
    viewBox: "0 0 91 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 91,
    height: 12,
    fill: "#B1AEAE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tnayin ashxatanq",
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 2880,
    transform: "translate(-825 -1198)",
    fill: "#010526"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1000002576"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line 105",
    d: "M90.5303 6.53033C90.8232 6.23744 90.8232 5.76256 90.5303 5.46967L85.7574 0.696699C85.4645 0.403806 84.9896 0.403806 84.6967 0.696699C84.4038 0.989593 84.4038 1.46447 84.6967 1.75736L88.9393 6L84.6967 10.2426C84.4038 10.5355 84.4038 11.0104 84.6967 11.3033C84.9896 11.5962 85.4645 11.5962 85.7574 11.3033L90.5303 6.53033ZM0 6.75L90 6.75V5.25L0 5.25L0 6.75Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 2880,
    fill: "white",
    transform: "translate(-825 -1198)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine);
export default __webpack_public_path__ + "static/media/Line.8583d984dba13059db7e3471dd1abdc8.svg";
export { ForwardRef as ReactComponent };